import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from '../players'; // Importing PlayersView component
import FilterCasinoReport from '../betShopManagement/reports/casinoReport/filterCasinoReport'; // Importing filter component for casino report
import TableCasinoReport from '../betShopManagement/reports/casinoReport/tableCasinoReport'; // Importing table component for casino report
import DetailsCasinoReport from '../betShopManagement/reports/casinoReport/detailsCasinoReport'; // Importing details component for casino report
import RecordCasinoReport from '../betShopManagement/reports/casinoReport/recordCasinoReport'; // Importing record component for casino report
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Casino Report View.
 * @extends JetView
 */
export default class CasinoReportView extends JetView {
    /**
     * Configures the layout of the Casino Report View.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme from app configuration
        const right = {
            // Configuration for the right section of the layout
            type: 'wide',
            rows: [RecordCasinoReport, DetailsCasinoReport], // Rows containing record and details components
        };
        const toolbar = {
            // Configuration for the toolbar
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                // Columns within the toolbar
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetch from configuration
                },
            ],
        };
        const left = {
            // Configuration for the left section of the layout
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label', // Label for the casino report title
                            label: _('Reporte de Casino'), // Localized label text
                            width: 500,
                        },
                    ],
                },
                FilterCasinoReport, // Including the filter component
                TableCasinoReport, // Including the table component
                toolbar, // Including the toolbar
            ],
        };
        return {
            // Returning the complete layout configuration
            type: 'wide',
            cols: [left, right], // Columns containing left and right sections
        };
    }
}

// FILE DOCUMENTED
